export default __webpack_public_path__ + "static/media/IconDesc_NuclearPasta.64.740fc67e.png";